import axios from 'axios';

export default async function fetchHealthPolicies(idNumber, requestConfig = {}) {
  const id = String(idNumber || '').trim();
  if (!id) return [];

  const response = await axios.get('/medical/policy/v1/client', {
    ...requestConfig,
    params: { idNumber: id },
  });
  const data = response.data || {};
  if (data.status && data.status !== 'Success') {
    throw new Error(data.message || 'Unable to load health policies');
  }
  return Array.isArray(data.policies) ? data.policies : [];
}
